import React, { useCallback, useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import { ThemeContext } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Filiais } from '../../models/Filiais';
import Button from '../../components/Button';
import ListRegistButton from '../../components/ListRegistButton';
import NewImportExel from '../../components/NewImportExel';
import NewInput from '../../components/NewInput';
import { NewSearch } from '../../components/NewSearch';
import PaginationComponent from '../../components/Pagination';
import Table from '../../components/Table';
import { TitlePage } from '../../components/TitlePage/styled';
import { useAuth } from '../../hooks/auth';
import ModalConexao from '../../components/ModalConexao';
import api from '../../services/api';

import {
  Container,
  ContainerCadastro,
  DivLineBottom,
  HeaderForm,
  LabelInputForm,
} from './styles';

interface GetSetores {
  id: number;
  name: string;
  companyId: number;
  createdAt: string;
}

const headers = [
  { name: 'Identificador', field: 'id', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Empresa', field: 'companyId', sortable: true },
  { name: 'Data de criação', field: 'createdAt', sortable: true },
  { name: 'Editar', field: 'editOption', sortable: true },
  { name: 'Remover', field: 'deleteOption', sortable: true },
];
const headersFilter = [{ name: 'Nome', field: 'name', sortable: true }];

const Apontamentos: React.FC = () => {
  const { empresaPrincipal } = useAuth();
  const { colors } = useContext(ThemeContext);
  const { go } = useHistory();
  const [filiais, setFiliais] = useState<Filiais[]>([]);

  const [setores, setSetores] = useState<GetSetores[]>([]);
  const [indexInitPg, setIndexInitPg] = useState(0);
  const [indexEndPg, setIndexEndPg] = useState(0);
  // const [filialSetor, setFilialSetor] = useState(0);
  const [nameSetor, setNameSetor] = useState('');
  const [idSetor, setIdSetor] = useState(0);
  const [SetoresFiltered, setSetoresFiltered] = useState<GetSetores[]>([]);
  const [cadastrar, setCadastrar] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (nameSetor !== '') {
      if (idSetor !== 0) {
        api
          .put('/Setores/', {
            name: nameSetor,
            id: idSetor,
            companyId: empresaPrincipal[0].ID,
          })
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Setor cadastrado com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
              showConfirmButton: false,
            });
            setTimeout(() => {
              setCadastrar(false);
              // eslint-disable-next-line no-restricted-globals
              history.go(0);
            }, 1000);
          })
          .catch(() => {
            console.log('Num foi não hein');
          });
      } else {
        api
          .post('/Setores/', {
            name: nameSetor,
            companyId: empresaPrincipal[0].ID,
          })
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Setor cadastrado com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
              showConfirmButton: false,
            });
            setTimeout(() => {
              setCadastrar(false);
              // eslint-disable-next-line no-restricted-globals
              history.go(0);
            }, 1000);
          })
          .catch(() => {
            console.log('Num foi não hein');
          });
      }
    }
  }, [empresaPrincipal, idSetor, nameSetor]);

  const getItems = useCallback(async () => {
    const SetoresGet = await api.get(
      `Setores?companyId=${empresaPrincipal[0].ID}`,
    );
    const FiliaisGet = await api.get(`/empresas/${empresaPrincipal[0].ID}`);

    setSetores(SetoresGet.data);
    setSetoresFiltered(SetoresGet.data);

    setFiliais(FiliaisGet.data);
  }, [empresaPrincipal]);

  useEffect(() => {
    getItems();
  }, [getItems]);

  const handleSubmitEdit = (idSetorEdit: number): void => {
    const setorCurrent = setores.find(({ id }) => id === idSetorEdit);

    setNameSetor(setorCurrent?.name!);
    setIdSetor(setorCurrent?.id!);
    setCadastrar(true);
  };

  const handleSubmitDelete = useCallback(
    (idSet: number): void => {
      Swal.fire({
        title: 'Tem certeza que deseja deletar?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonColor: colors.success,
        cancelButtonColor: colors.error,
        confirmButtonText: 'Sim',
      }).then((result) => {
        if (result.isConfirmed) {
          const obj = { id: idSet };
          api
            .delete('/setores', { data: obj })
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Setor deletedo com sucesso!',
                showClass: {
                  popup: 'animate__animated animate__fadeInDown',
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp',
                },
                showConfirmButton: false,
              });
              setTimeout(() => {
                setCadastrar(false);
                go(0);
              }, 1000);
            })
            .catch((err) => {
              console.log('ERRR', err.message);
              Swal.fire({
                icon: 'error',
                title: 'Ocorreu um erro ao deletar Setor!',
                showClass: {
                  popup: 'animate__animated animate__fadeInDown',
                },
                hideClass: {
                  popup: 'animate__animated animate__fadeOutUp',
                },
                showConfirmButton: false,
              });
            });
        }
      });
      //
    },
    [colors.error, colors.success, go],
  );

  return (
    <>
      <ModalConexao />
      <Container>
        <TitlePage>Setores</TitlePage>
        <ListRegistButton
          object={{ list: 'Listar', regist: 'Registrar' }}
          setStateCadastrar={setCadastrar}
          stateCadastrar={cadastrar}
        />
        {!cadastrar && (
          <>
            <NewSearch
              arraySetState={setSetoresFiltered}
              arrayState={setores}
              selectFilters={headersFilter}
            />
            <Table
              header={headers}
              body={SetoresFiltered.filter(
                (e, i) => i >= indexInitPg && i <= indexEndPg,
              )}
              tableId="TableSetores"
              filiais={filiais}
              setEditId={(id) => {
                handleSubmitEdit(id);
              }}
              setRemoveId={(id) => {
                handleSubmitDelete(id);
              }}
            />
            <PaginationComponent
              arrayStateFiltered={SetoresFiltered}
              setIndexPagination={(indexInit, indexEnd) => {
                setIndexInitPg(indexInit);
                setIndexEndPg(indexEnd);
              }}
            />
            <NewImportExel fileName="Setores" tableId="TableSetores" />
          </>
        )}
        {cadastrar && (
          <ContainerCadastro>
            <HeaderForm>Cadastro de Vistorias</HeaderForm>
            <DivLineBottom />
            <LabelInputForm>Nome</LabelInputForm>
            <NewInput
              name="Setores"
              placeholder="Digite aqui..."
              setStateValue={setNameSetor}
              stateValue={nameSetor}
            />
            <div className="buttonContainer">
              <Button id="cancel">Cancelar</Button>
              <Button onClick={handleSubmit}>Salvar</Button>
            </div>
          </ContainerCadastro>
        )}
      </Container>
    </>
  );
};

export default Apontamentos;
